// Fiók-státusz badge — a jel a KÖZÖS badge-katalógus `lifecycle` fogalmából (`domain-badge.tsx`): az
// `active`/`pending`/`inactive` hármas ugyanazt jelenti az ügyfélnél, a fióknál és a szolgáltatás-
// hozzárendelésnél is, ezért EGY térkép írja le.
import { DomainBadge } from '@/components/shared/domain-badge';

export interface AccountStatusBadgeProps {
  /** A nyers státusz-string (szín + ikon forrása). */
  status: string;
  /** A megjelenített (lokalizált) címke — a hívó adja `t('accounts.statusLabel.…')`-ből. */
  label: string;
  className?: string;
}

export function AccountStatusBadge({
  status,
  label,
  className,
}: AccountStatusBadgeProps): JSX.Element {
  return <DomainBadge kind="lifecycle" value={status} label={label} className={className} />;
}
